/* assets/pbm-sticky-atc.js  PBM sticky Add to cart (SPEC_FINAL 2026-10-12).
   Vanilla JS, no dependencies, no globals. Works before and after jQuery / utilities.js / app.js load.
   It PROXIES the real order-table form and never posts a form of its own:
     form mode (Layout A, and AB pages): the row in .product-bottom-form
     row mode  (order grid with exactly one buyable row): that row's visible form
     grid mode (order grid with 2+ buyable rows): the button scrolls to the grid
   Add = write the quantity into the real input (input + change), then realButton.click(), so the theme, Wholesale
   Gorilla, Searchanise, Shopify's pixels and snippets/pbm-clarity-events.liquid see the same click and submit a tap
   produces. Nothing to proxy -> the bar stays [hidden] and the page is untouched. */
(function () {
  'use strict';
  var d = document;
  var w = window;
  var bar = d.getElementById('pbm-satc');
  if (!bar || bar.getAttribute('data-ready')) return;

  var KEY = 'pbm_satc_add';
  var HYST = 16;                                   // px of hysteresis at both edges of the hide zone
  var TITLE_MIN = 78;                              // phone line 2: a product name box narrower than this (about 10
                                                   // characters of 13px bold plus the ellipsis) reads as a broken
                                                   // stub ("TRAU...", 40-57px): drop the name instead
  var QTY_LIST = (function () { var a = []; for (var i = 1; i <= 100; i++) a.push(i); return a.concat([125, 150, 200, 250, 300, 400, 500]); })();
  var OVERLAY = ['mobile-menu--opened', 'show-mega-menu', 'fancybox-active', 'snize-instant-widget-is-open'];
  var DROP = ['signin', 'count', 'sku', 'title', 'gate'];   // line-2 items, dropped in this order to fit

  function attr(n, f) { var v = bar.getAttribute(n); return v == null || v === '' ? f : v; }
  var pid = attr('data-product-id', '');
  var hideSku = bar.getAttribute('data-hide-sku') === 'true';
  var singleRow = attr('data-single-row', 'add');
  var L = {
    add: attr('data-label-add', 'Add to cart'),
    added: attr('data-label-added', 'Added'),
    soldout: attr('data-label-soldout', 'Sold Out'),
    unavailable: attr('data-label-unavailable', ''),
    grid: attr('data-label-grid', 'Choose items'),
    one: attr('data-count-one', '1 item'),
    other: attr('data-count-other', '2 items')
  };

  /* ---------------------------------------------------------------- helpers */
  function q(s, r) { return (r || d).querySelector(s); }
  function qa(s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); }
  function txt(el) { return el ? (el.textContent || '').replace(/\s+/g, ' ').trim() : ''; }
  function shown(el) {
    if (!el || !el.isConnected || !el.getClientRects().length) return false;
    return w.getComputedStyle(el).visibility !== 'hidden';
  }
  function opaque(el, stop) {
    for (var n = el; n && n !== d.body; n = n.parentElement) {
      if (parseFloat(w.getComputedStyle(n).opacity) < 0.01) return false;
      if (n === stop) break;
    }
    return true;
  }
  function setText(el, s) { if (el && el.textContent !== s) { el.textContent = s; return true; } return false; }
  function fire(el, type) { try { el.dispatchEvent(new Event(type, { bubbles: true })); } catch (e) {} }
  function mq(s) { try { return w.matchMedia(s); } catch (e) { return { matches: false }; } }
  var reducedQ = mq('(prefers-reduced-motion: reduce)');
  var phoneQ = mq('(max-width: 798px)');
  var narrowQ = mq('(max-width: 599px)');
  var coarse = mq('(pointer: coarse)').matches || mq('(hover: none)').matches;
  var raf = w.requestAnimationFrame ? w.requestAnimationFrame.bind(w) : function (f) { return setTimeout(f, 16); };
  function clarity() { try { if (typeof w.clarity === 'function') w.clarity.apply(w, arguments); } catch (e) {} }
  function cartCount() { var c = parseInt(bar.getAttribute('data-cart-count'), 10); return isFinite(c) ? c : -1; }

  /* ---------------------------------------------------------------- what to proxy */
  function cartForm(row) {
    var fs = qa('form[action*="/cart/add"]', row);
    for (var i = 0; i < fs.length; i++) if (shown(fs[i]) && q('button[name="add"]', fs[i])) return fs[i];
    return null;
  }
  function resolve() {
    var r = { mode: '', row: null, table: null, extra: [], count: 0 };
    var rowA = q('.product-bottom-form tr.product-order-form:not(.top-title)');
    if (rowA && cartForm(rowA)) { r.mode = 'form'; r.row = rowA; }
    var secs = qa('.product-order-form-section');
    for (var i = 0; i < secs.length; i++) {
      // Layout A pages carry an empty display:none wrapper; N2 pages a visible one with 0 rows: count buyable rows only
      var rows = qa('tr.product-order-form:not(.top-title)', secs[i]).filter(function (tr) { return shown(tr) && !!cartForm(tr); });
      if (!rows.length) continue;
      var table = q('table.product-order-form__row', secs[i]) || secs[i];
      if (r.mode === 'form') { r.extra.push(table); break; }          // AB page: proxy the main form
      r.table = table;
      r.count = rows.length;
      // One-row grids (LJ 10/14, "choose items button where appropriate"): "auto" sends the buyer to the row when it
      // has an each/case toggle (a real choice to make) and adds straight from the bar when it does not.
      var oneRowChoice = rows.length === 1 && qa('.custom-variants-btn .btn', rows[0]).filter(shown).length > 1;
      if (rows.length === 1 && (singleRow === 'add' || (singleRow === 'auto' && !oneRowChoice))) { r.mode = 'row'; r.row = rows[0]; }
      else r.mode = 'grid';
      break;
    }
    return r.mode ? r : null;
  }

  var el = {
    title: q('[data-satc-title]', bar), info: q('.pbm-satc__info', bar), sub: q('.pbm-satc__sub', bar),
    pack2: q('[data-satc-pack2]', bar), sku: q('[data-satc-sku]', bar), count: q('[data-satc-count]', bar),
    gate: q('[data-satc-gate]', bar), badge: q('[data-satc-badge]', bar), signin: q('[data-satc-signin]', bar),
    price: q('[data-satc-price]', bar), amount: q('[data-satc-amount]', bar), pack: q('[data-satc-pack]', bar),
    qtybox: q('[data-satc-qtybox]', bar), sel: q('[data-satc-qty]', bar), qv: q('[data-satc-qty-value]', bar),
    btn: q('[data-satc-btn]', bar), label: q('[data-satc-label]', bar), slot: q('.pbm-satc__slot', bar)
  };
  var live = d.getElementById('pbm-satc-live');
  // Short title (title fix 2026-10-17): data-short-title (Liquid: custom.sticky_title, else snippets/pbm-sticky-titles).
  // fit() shows it only while the full title overflows its box; every fit starts again from the full title.
  var titleLong = el.title.textContent;            // the full title: product.title as Liquid printed it; row mode: the row's
  var titleShort = (el.title.getAttribute('data-short-title') || '').replace(/\s+/g, ' ').trim();
  // the product the short title names: data-short-for (a page whose one-row grid is another product), else this page's
  var shortFor = (el.title.getAttribute('data-short-for') || '').trim() || pid;

  var mode = '';
  var row = null;
  var table = null;
  var targets = [];
  var rowMO = null;
  var state = 'idle';            // idle | loading | added | soldout
  var want = null;               // what the hide zone says (null until both observers reported)
  var visible = false;           // .is-visible (slid in)
  var overlay = false;
  var typing = false;
  var pinned = false;
  var H = 0;                     // px the stuck header covers at the top
  var B = 0;                     // bar height incl. safe area
  var stuckH = 0;
  var ioS = null, ioL = null, ioG = null, ioD = null, ioDFor = null, reported = 0;
  var guest = false, gateOn = true, pageGate = null;
  var idleLabel = L.add;
  var tAdded = 0, tAjax = 0;
  var expecting = null, lastSubmit = null;
  var optSig = '';
  var held = null;               // qty just added, shown in the chip while "Added" is up
  var kbd = false;               // the last focus-moving input was Tab / Shift+Tab (the only keys that move focus into the
                                 // bar); a pointer or touch press clears it, any other key leaves it as it is
  var keyAct = false;            // the last input was Enter / Space (a keyboard activation: "Choose items" rings the table)
  var kbdFocus = false;          // focus ENTERED the bar by keyboard (Tab / Shift+Tab): only this pins the bar and draws
                                 // its rings (data-kbd). A key pressed after a mouse or touch focus never does.
  var press = 0;                 // a pointer / touch press that started on the bar is under way (1; 2 = on the chip): the
                                 // bar never unpins (slides out) under the finger; it unpins once the press has done its
                                 // work (the click, or the chip's pick)
  var parkEl = null;             // the bar element that held focus when the window lost focus: Chrome re-sends focusin to
                                 // it when the window is re-activated, and that focusin keeps the value it had
  var dirUp = null;              // grid: the table is above the middle of the screen (the arrow's wanted direction)
  var inputSeq = 0;              // bumps on every key, pointer, touch or wheel input
  var titleFull = 0;             // phone line 2: the title's own text width, measured by fit()
  var fitW = -1;                 // the width fit() last ran for: a width change refits in the same frame
  var tInert = 0;
  var dirWait = false;           // a turn held for a due hide waits for its re-check (two frames and a task)
  var unwatchNav = null;

  function current() {
    if (!row) return null;
    var f = cartForm(row);
    if (!f) return null;
    return { form: f, btn: q('button[name="add"]', f), qty: q('input[name="quantity"]', f) };
  }
  // The short title names one product (shortFor) and shows only while the bar shows that product: form and grid modes
  // show this page's product, row mode the row's (its tr carries class product-<id>). Any other product keeps its title.
  function rowPid() { var m = row && /(?:^|\s)product-(\d+)(?:\s|$)/.exec(row.className || ''); return m ? m[1] : ''; }
  function shortOn() { return !!titleShort && (mode === 'row' ? rowPid() : pid) === shortFor; }

  /* ---------------------------------------------------------------- state */
  function setState(s) {
    state = s;
    if (s !== 'added') { held = null; bar.removeAttribute('data-added'); }
    bar.setAttribute('data-state', s);
    var off = s === 'loading' || s === 'soldout';
    if (off) el.btn.setAttribute('aria-disabled', 'true'); else el.btn.removeAttribute('aria-disabled');
    if (s === 'loading') el.btn.setAttribute('aria-busy', 'true'); else el.btn.removeAttribute('aria-busy');
    el.sel.disabled = off || el.qtybox.classList.contains('is-locked');
    apply();
  }
  function retire() {                              // the target vanished: hide for good, keep the reserve (no jump)
    mode = 'off';
    [ioS, ioL, ioG, ioD, rowMO].forEach(function (o) { if (o) o.disconnect(); });
    ioD = null; ioDFor = null;
    visible = false;
    bar.classList.remove('is-visible');
    clearTimeout(tInert); tInert = 0;
    setInert(true);
  }
  function setInert(on) {
    if (on) { bar.setAttribute('inert', ''); bar.setAttribute('aria-hidden', 'true'); }
    else { bar.removeAttribute('inert'); bar.removeAttribute('aria-hidden'); }
  }

  /* ---------------------------------------------------------------- mirror the real row */
  function readPrice() {
    var ps = qa('.of-product-price', row);
    for (var i = 0; i < ps.length; i++) {
      if (shown(ps[i]) && opaque(ps[i], row)) {
        return { amount: txt(ps[i]), pack: txt(q('.fproduct-s-text', row) || q('.box-quantity p', row)) };
      }
    }
    var t = q('.custom-variants-btn .btn.active', row);          // each/case rows: the active toggle, verbatim
    if (t && shown(t) && opaque(t, row)) {
      var s = txt(t);
      var k = s.indexOf(' ');
      return k > 0 ? { amount: s.slice(0, k), pack: s.slice(k + 1) } : { amount: s, pack: '' };
    }
    return { amount: '', pack: '' };
  }
  function realLabel(b) { var s = (b.getAttribute('data-label') || '').replace(/^"+|"+$/g, '').trim(); return s || L.add; }
  function realOff(b) { return !!(b.disabled || b.classList.contains('disabled') || b.getAttribute('aria-disabled') === 'true'); }
  function offLabel(b) { var s = txt(q('.text', b)); return s && s !== realLabel(b) ? s : L.soldout; }

  // The row prints its own product's SKU. A pack form (each/case toggle, .p-product) adds another product, whose SKU
  // the page never renders: show none rather than a SKU the cart line will not carry.
  function skuText(t) {
    if (hideSku) return '';
    var s = txt(q('.of-product-sku', row));
    if (!s || (t.form.closest && t.form.closest('.p-product'))) return '';
    var m = /(?:^|\s)product-(\d+)(?:\s|$)/.exec(row.className || '');
    var fp = q('input[name="product-id"]', t.form);
    if (m && fp && fp.value && fp.value !== m[1]) return '';
    return 'SKU: ' + s;
  }
  function sync() {
    if (mode !== 'form' && mode !== 'row') return;
    if (state === 'loading') return;               // frozen while the add is in flight: the bar keeps showing what it adds
    if (!row || !row.isConnected) { if (!reresolve()) return; }
    var t = current();
    if (!t || !t.btn) { retire(); return; }        // the theme renders no button when the product is unavailable
    var changed = false;
    var p = readPrice();
    if (setText(el.amount, p.amount)) changed = true;
    if (setText(el.pack, p.pack)) changed = true;
    if (setText(el.pack2, p.pack)) changed = true;
    if (el.price.hidden !== !p.amount) { el.price.hidden = !p.amount; changed = true; }
    // row mode: the row's title is the full title (fit() may show the short title in its place)
    if (mode === 'row') { var rt = txt(q('.title-wrap', row)); if (rt && rt !== titleLong) { titleLong = rt; setText(el.title, rt); changed = true; } }
    if (setText(el.sku, skuText(t))) changed = true;
    idleLabel = realLabel(t.btn);
    if (state !== 'loading' && state !== 'added') {
      if (realOff(t.btn)) { if (setText(el.label, offLabel(t.btn))) changed = true; if (state !== 'soldout') setState('soldout'); }
      else { if (setText(el.label, idleLabel)) changed = true; if (state === 'soldout') setState('idle'); }
    }
    if (d.activeElement !== el.sel) pullQty(t);
    if (changed) scheduleFit();
  }
  function reresolve() {
    var r = resolve();
    if (!r || r.mode !== mode) { retire(); return false; }
    row = r.row; table = r.table;
    setTargets(r);
    bindRow();
    build();
    return true;
  }
  var syncQ = false;
  function scheduleSync() { if (syncQ) return; syncQ = true; raf(function () { syncQ = false; sync(); }); }

  /* ---------------------------------------------------------------- quantity (native select at every width) */
  function limits(input) {
    var mn = input ? parseInt(input.getAttribute('min'), 10) : 1;
    var mx = input ? parseInt(input.getAttribute('max'), 10) : NaN;
    if (!(mn >= 1)) mn = 1;
    if (!(mx >= mn)) mx = Infinity;
    return { min: mn, max: mx };
  }
  function clamp(v, lim) { var n = parseInt(v, 10); if (!(n >= lim.min)) n = lim.min; if (n > lim.max) n = lim.max; return n; }
  function buildOptions(lim, cur) {
    var list = QTY_LIST.filter(function (n) { return n >= lim.min && n <= lim.max; });
    if (!list.length || list[0] !== lim.min) list.unshift(lim.min);
    if (list.indexOf(cur) < 0) { list.push(cur); list.sort(function (a, b) { return a - b; }); }
    var sig = list.join(',');
    if (sig === optSig) return false;
    optSig = sig;
    var frag = d.createDocumentFragment();
    list.forEach(function (n) { var o = d.createElement('option'); o.value = String(n); o.textContent = String(n); frag.appendChild(o); });
    el.sel.textContent = '';
    el.sel.appendChild(frag);
    return true;
  }
  // The chip's value box is reserved at the widest option (lockChip), so picking a quantity moves and refits nothing.
  // Only a new option list (a different min / max, or an inserted real value) can change the reserved width.
  function setBarQty(n, lim) {
    var relist = buildOptions(lim, n);
    el.sel.value = String(n);
    setText(el.qv, String(n));
    if (relist) scheduleFit();
  }
  function pullQty(t) {
    if (state === 'loading') return;               // frozen while the add is in flight
    t = t || current();
    if (!t || !t.qty) { el.qtybox.classList.add('is-locked'); el.sel.disabled = true; setBarQty(1, { min: 1, max: Infinity }); return; }
    if (el.qtybox.classList.contains('is-locked')) { el.qtybox.classList.remove('is-locked'); el.sel.disabled = state === 'loading' || state === 'soldout'; }
    var lim = limits(t.qty);
    setBarQty(clamp(held != null ? held : t.qty.value, lim), lim);
  }
  function pushQty(v) {
    var t = current();
    if (!t || !t.qty) return;
    var lim = limits(t.qty);
    var n = clamp(v, lim);
    if (t.qty.value !== String(n)) { t.qty.value = String(n); fire(t.qty, 'input'); fire(t.qty, 'change'); }
    setBarQty(clamp(t.qty.value, lim), lim);        // follow the theme if it re-clamped the real input
  }
  function onRowEvent(e) {
    var t = e.target;
    if (e.type === 'click') {
      if (t && t.closest && t.closest('.quantity-wrapper, .custom-variants-btn')) { if (state === 'added') held = null; setTimeout(scheduleSync, 0); }
      return;
    }
    // The buyer edited the real row during "Added" (its +/-, the toggle, or typing): the chip follows the row again.
    // Typed edits count only when trusted: a script that sets the row's minimum on load must not undo the held qty.
    // (The bar only writes the row from its own select, which already drops the held qty.)
    if (t && t.name === 'quantity') { if (state === 'added' && e.isTrusted) held = null; scheduleSync(); }
  }
  var boundRow = null;
  function bindRow() {
    if (boundRow === row) return;
    if (boundRow) ['input', 'change', 'click'].forEach(function (ty) { boundRow.removeEventListener(ty, onRowEvent, false); });
    boundRow = row;
    if (!row) return;
    ['input', 'change', 'click'].forEach(function (ty) { row.addEventListener(ty, onRowEvent, false); });
    if (w.MutationObserver) {
      if (!rowMO) rowMO = new MutationObserver(scheduleSync);
      rowMO.disconnect();
      rowMO.observe(row, { subtree: true, childList: true, characterData: true, attributes: true });
    }
  }

  /* ---------------------------------------------------------------- add (form and row modes) */
  w.addEventListener('submit', function (e) { if (expecting && e.target === expecting) lastSubmit = e; }, true);

  function add() {
    if (mode !== 'form' && mode !== 'row') return;
    if (state === 'added') {
      clearTimeout(tAdded);
      var hq = held;                                 // the chip shows the qty just added: a tap now adds that (WYSIWYG)
      if (live) live.textContent = '';
      setState('idle');
      if (hq != null) pushQty(hq);
    }
    if (state !== 'idle') return;
    sync();
    if (state !== 'idle' || (mode !== 'form' && mode !== 'row')) return;
    var t = current();
    if (!t || !t.btn || realOff(t.btn)) return;
    if (t.qty) pushQty(el.sel.value);
    if (typeof t.form.checkValidity === 'function' && !t.form.checkValidity()) {
      scrollToEl(row, null);                       // let the real form explain itself
      setTimeout(function () { try { t.form.reportValidity(); } catch (e) {} }, reducedQ.matches ? 0 : 500);
      return;
    }
    setState('loading');                            // synchronous lock: a second tap is ignored
    var vid = q('[name="id"]', t.form);             // never form.id (the input named id shadows it)
    try {
      w.sessionStorage.setItem(KEY, JSON.stringify({ t: Date.now(), p: pid, c: cartCount(), m: mode,
        v: vid ? String(vid.value) : '', q: t.qty ? clamp(t.qty.value, limits(t.qty)) : 1 }));
    } catch (e) {}
    clarity('set', 'pbm_satc_mode', mode);
    clarity('event', 'pbm_sticky_atc_click');
    expecting = t.form;
    lastSubmit = null;
    var unwatch = watchNav();
    try { t.btn.click(); } catch (e) {}
    expecting = null;
    if (!lastSubmit) {                              // nothing was submitted: a handler stopped it, or the button was disabled
      if (unwatch) unwatch();
      try { w.sessionStorage.removeItem(KEY); } catch (e) {}
      setState('idle');
      sync();
      return;
    }
    if (lastSubmit.defaultPrevented) { if (unwatch) unwatch(); watchAjax(); }   // a script took the add over (AJAX cart)
    // Native POST (cart_action = reload_page): stay locked until the page navigates. No timer re-arm (no double add);
    // pageshow with persisted = true unlocks after Back, and watchNav() unlocks after the buyer pressed Stop.
  }
  // Stop (Esc, the address-bar X) aborts the native POST: the Navigation API reports it with navigateerror. Unlock then,
  // as the real button is usable again, unless another navigation has taken over (the page is leaving anyway).
  function watchNav() {
    var N = w.navigation;
    if (!N || typeof N.addEventListener !== 'function') return null;
    var ours = false, other = false, tErr = 0;
    function onNav(e) {
      var u = '';
      try { u = (e.destination && e.destination.url) || ''; } catch (x) {}
      if (!ours && /\/cart\/add(\.js)?([?#]|$)/.test(u)) ours = true; else other = true;
    }
    function onErr() {
      clearTimeout(tErr);
      tErr = setTimeout(function () {               // let a navigation that replaced ours announce itself first
        var unlock = ours && !other;
        off();
        if (!unlock || state !== 'loading') return;
        try { w.sessionStorage.removeItem(KEY); } catch (x) {}
        setState('idle');
        sync();
      }, 0);
    }
    function off() {
      try { N.removeEventListener('navigate', onNav); N.removeEventListener('navigateerror', onErr); } catch (x) {}
      w.removeEventListener('pagehide', off);
      if (unwatchNav === off) unwatchNav = null;
    }
    if (unwatchNav) unwatchNav();
    N.addEventListener('navigate', onNav);
    N.addEventListener('navigateerror', onErr);
    w.addEventListener('pagehide', off);
    unwatchNav = off;
    return off;
  }
  function watchAjax() {
    var done = false, po = null;
    function finish(ok) {
      if (done) return;
      done = true;
      clearTimeout(tAjax);
      try { if (po) po.disconnect(); } catch (e) {}
      try { w.sessionStorage.removeItem(KEY); } catch (e) {}
      if (ok) confirmAdded(); else { setState('idle'); sync(); }
    }
    try {
      if (w.PerformanceObserver) {
        po = new PerformanceObserver(function (list) {
          list.getEntries().forEach(function (en) {
            if (/\/cart\/add(\.js)?(\?|$)/.test(en.name)) finish(!en.responseStatus || en.responseStatus < 400);
          });
        });
        po.observe({ type: 'resource', buffered: false });
      }
    } catch (e) {}
    tAjax = setTimeout(function () { finish(false); }, 15000);
  }
  function confirmAdded(qn, boot) {
    clearTimeout(tAdded);
    setState('added');
    if (qn > 0) { held = qn; pullQty(); }          // the chip shows what was just added, not the reloaded row's default
    if (boot) bar.setAttribute('data-added', 'boot');   // set before the first slide-in: the check draws once it lands
    setText(el.label, L.added);
    if (live) live.textContent = L.added;
    tAdded = setTimeout(function () {
      if (live) live.textContent = '';
      if (state === 'added') { setState('idle'); sync(); }
    }, 2600);
  }

  /* ---------------------------------------------------------------- header + grid navigation */
  function headerEl() {
    var m = d.getElementById('mobile-header');
    if (shown(m)) return m;
    var h = d.getElementById('header');
    return shown(h) ? h : null;
  }
  function isStuck(h) { var p = w.getComputedStyle(h).position; return p === 'fixed' || p === 'sticky'; }
  function headerCover() {
    var h = headerEl();
    if (!h || !isStuck(h)) return 0;
    var r = h.getBoundingClientRect();
    if (r.bottom <= 0) return 0;
    stuckH = Math.round(r.height);
    return Math.min(240, Math.round(r.bottom));
  }
  function landing() {
    var h = headerEl();
    if (!h) return 12;
    var r = h.getBoundingClientRect();
    return Math.round(isStuck(h) ? r.height : (stuckH || r.height)) + 12;
  }
  function scrollToEl(target, focusEl, viaKbd) {
    var smooth = !reducedQ.matches;
    var top = target.getBoundingClientRect().top + (w.pageYOffset || d.documentElement.scrollTop) - landing();
    try { w.scrollTo({ top: Math.max(0, top), behavior: smooth ? 'smooth' : 'auto' }); } catch (e) { w.scrollTo(0, Math.max(0, top)); }
    var settled = false, seq0 = inputSeq;
    function settle() {
      if (settled) return;
      settled = true;
      var delta = target.getBoundingClientRect().top - landing();   // the header can change height on the way
      // never pull back a buyer who scrolled (wheel, touch, pointer, key) since the click
      if (Math.abs(delta) > 4 && inputSeq === seq0) { try { w.scrollBy({ top: delta, behavior: smooth ? 'smooth' : 'auto' }); } catch (e) { w.scrollBy(0, delta); } }
      if (focusEl) {
        if (!focusEl.hasAttribute('tabindex')) focusEl.setAttribute('tabindex', '-1');
        // ring only when the click came from the keyboard (Enter / Space): after a mouse or touch click, a later key
        // press (PageDown, Space, an arrow) makes Chrome match :focus-visible on the table, and must not frame it
        focusEl.setAttribute('data-satc-target', viaKbd ? 'kbd' : '');
        try { focusEl.focus({ preventScroll: true }); } catch (e) {}
      }
    }
    if (smooth && 'onscrollend' in w) w.addEventListener('scrollend', settle, { once: true });
    setTimeout(settle, smooth ? 900 : 0);
  }
  function goGrid() {
    clarity('set', 'pbm_satc_mode', 'grid');
    clarity('event', 'pbm_sticky_atc_click');
    scrollToEl(table, table, keyAct);               // focus the table, never an input: no phone keyboard
  }

  /* ---------------------------------------------------------------- visibility */
  function kind(node, k) { node.__satcKind = k; return node; }
  function setTargets(r) {
    targets = [];
    if (r.mode === 'grid') targets.push(kind(r.table, 'any'));
    else {
      var t = current();
      targets.push(kind(q('td.fproduct-form', r.row) || (t && t.btn) || r.row, 'full'));
      r.extra.forEach(function (x) { targets.push(kind(x, 'any')); });
    }
  }
  function barHeight() { var h = Math.round(bar.offsetHeight); return h > 0 ? h : (phoneQ.matches ? 64 : 72); }
  function hit(e) { return e.target.__satcKind === 'full' ? (e.isIntersecting && e.intersectionRatio >= 0.98) : e.isIntersecting; }
  function build() {
    if (mode === 'off') return;
    H = headerCover();
    B = barHeight();
    d.documentElement.style.setProperty('--pbm-satc-h', B + 'px');
    [ioS, ioL, ioG].forEach(function (o) { if (o) o.disconnect(); });
    if (!('IntersectionObserver' in w)) { want = true; apply(); return; }
    reported = 0;
    // Grid: "Choose items" points to where the table is. The root is everything above the middle of the screen, so the
    // report also comes when a jump (End, Home, an anchor) carries the table past the screen without crossing the zone.
    // Whenever the bar shows, the table is outside the zone: some of it above the middle means all of it is above.
    // Its root depends on neither the header nor the bar, so it is kept across rebuilds (the desktop stuck header's
    // shrink after a jump rebuilds every frame for about 100 ms); only a new table gets a new observer. Its first report
    // is set at once, never turned (setDir), so the arrow is right before the first slide-in brings it on screen.
    if (mode === 'grid' && table && ioDFor !== table) {
      if (ioD) ioD.disconnect();
      ioDFor = table;
      ioD = new IntersectionObserver(function (es) { setDir(es[es.length - 1].isIntersecting); }, { rootMargin: '100000px 0px -50% 0px', threshold: [0] });
      ioD.observe(table);
    }
    var th = [0, 0.5, 0.98, 1];
    var strict = (-H) + 'px 0px ' + (-B) + 'px 0px';
    var loose = (HYST - H) + 'px 0px ' + (HYST - B) + 'px 0px';
    ioS = new IntersectionObserver(function (es) { es.forEach(function (e) { e.target.__satcS = hit(e); }); reported |= 1; evaluate(); }, { rootMargin: strict, threshold: th });
    ioL = new IntersectionObserver(function (es) { es.forEach(function (e) { e.target.__satcL = hit(e); }); reported |= 2; evaluate(); }, { rootMargin: loose, threshold: th });
    targets.forEach(function (t) { ioS.observe(t); ioL.observe(t); });
    if (guest && pageGate) {
      ioG = new IntersectionObserver(function (es) { gateOn = es[es.length - 1].isIntersecting; renderGate(); }, { rootMargin: strict, threshold: [0] });
      ioG.observe(pageGate);
    }
  }
  // The arrow never snaps where the buyer can see it: it changes at once while it is not painted (applyDir's "off"), and
  // with a short turn (dir-turn) while the bar stays on screen (End / Home, a restored scroll position). While the bar
  // slides out with the arrow still on screen it keeps pointing where the buyer tapped; the new direction lands at the
  // slide's end (tInert) or right before the bar comes back.
  // A turn on screen needs the hide zone's verdict for the same page position. Chrome delivers the observers in no
  // fixed order (not in creation order), and sometimes delivers the hide zone's report in a later task than the
  // direction's, so the turn is checked against the page itself: while the table is in the hide zone and nothing else
  // keeps the bar up, a hide is due, and the turn waits for it. The check runs again two frames later and then trusts
  // the observers (the hide has landed by then, or they kept the bar shown).
  function setDir(up) {
    var first = dirUp === null;
    dirUp = !!up;
    if (first) { if (dirUp) bar.setAttribute('data-dir', 'up'); return; }   // the first direction is set, never turned
    applyDir();
  }
  function hideDue() {
    if (pinned || state === 'loading' || keyboardInside() || !targets.length) return false;
    return zoneNow(H, w.innerHeight - B).s;
  }
  function applyDir(late) {
    if (dirUp === null) return;
    // not painted: inert (hidden, suppressed, before the first show), the slide-out already over (its visibility flips
    // to hidden at 260 ms, inert follows at 270 ms), or the arrow itself already below the screen edge (a bar that dips
    // to a few px on a fast fling and comes straight back)
    var off = bar.hasAttribute('inert') || w.getComputedStyle(bar).visibility === 'hidden' ||
      el.slot.getBoundingClientRect().top >= w.innerHeight - 0.5;
    if (off) bar.classList.remove('dir-turn');
    if ((bar.getAttribute('data-dir') === 'up') === dirUp) return;
    if (!off) {
      if (!visible) return;
      if (late !== true && hideDue()) {
        if (!dirWait) { dirWait = true; raf(function () { raf(function () { setTimeout(function () { dirWait = false; if (mode !== 'off') applyDir(true); }, 0); }); }); }
        return;
      }
      bar.classList.add('dir-turn');
    }
    if (dirUp) bar.setAttribute('data-dir', 'up'); else bar.removeAttribute('data-dir');
  }
  function evaluate() {
    if (pinned || reported !== 3) return;           // wait for both observers: no flash on load
    var s = false, l = false;
    targets.forEach(function (t) { if (t.__satcS) s = true; if (t.__satcL) l = true; });
    decide(s, l);
  }
  // Hysteresis: hide when a target is in the strict zone; show again only once it is out of the zone grown by HYST.
  function decide(s, l) {
    if (want === null) want = !s;
    else if (want && s) want = false;
    else if (!want && !l) want = true;
    apply();
  }
  // Keyboard focus pins the bar; mouse and touch focus never do, not even after a later key press (Chrome then matches
  // :focus-visible on a mouse-focused button or select, so :focus-visible and the last modality cannot decide). What
  // counts is how focus ENTERED the bar: a focusin while the last input was a key (Tab, Shift+Tab).
  function keyboardInside() {
    var a = d.activeElement;
    if (!kbdFocus || !a || !bar.contains(a)) return false;
    return !(a.tagName === 'SELECT' && coarse);      // a touch device's "next field" key never pins the picker
  }
  function setKbdFocus(v) {
    if (v === kbdFocus) return;
    kbdFocus = v;
    if (v) bar.setAttribute('data-kbd', ''); else bar.removeAttribute('data-kbd');
    apply();
  }
  function apply() {
    if (mode === 'off' || mode === '') return;
    var sup = overlay || typing;
    var v = !!(want || state === 'loading' || keyboardInside());
    bar.classList.toggle('is-suppressed', sup);
    if (v !== visible) {
      if (v) applyDir();                            // still hidden: a waiting arrow direction lands before the slide-in
      visible = v;
      bar.classList.toggle('is-visible', v);
      if (v && mode !== 'grid') { pullQty(); scheduleSync(); }
    }
    if (visible && !sup) { clearTimeout(tInert); tInert = 0; setInert(false); }
    else if (sup || reducedQ.matches) { clearTimeout(tInert); tInert = 0; setInert(true); }   // instant hide: instant inert
    else if (!tInert && !bar.hasAttribute('inert')) {
      // slide-out: the bar stays tappable while it is still painted (260 ms), so a tap never falls through to the page
      tInert = setTimeout(function () { tInert = 0; if (!visible || overlay || typing) { setInert(true); applyDir(); } }, 270);
    }
    applyDir();
  }
  // The hide zone measured now (the observers report only at the next rendering update).
  function zoneNow(top, bot) {
    var z = { s: false, l: false };
    targets.forEach(function (t) {
      var r = t.getBoundingClientRect();
      if (zoneHit(t, r, top, bot)) z.s = true;
      if (zoneHit(t, r, top - HYST, bot + HYST)) z.l = true;
    });
    return z;
  }
  function readOverlay() {
    var b = d.body;
    var o = b.style.position === 'fixed';
    for (var i = 0; i < OVERLAY.length && !o; i++) if (b.classList.contains(OVERLAY[i])) o = true;
    if (o !== overlay) {
      var ended = overlay && !o;
      overlay = o;
      // An overlay ends: the observers' verdict is stale. The phone menu scroll-locks the page at the top while it is
      // open, and its close puts the scroll position back in the same task as it drops the body class, so the last
      // report describes the locked page. Decide from the page as it is now, before the suppression comes off: the bar
      // never pops up at the row and slides away (the next report agrees with this one).
      if (ended && !pinned && reported === 3 && targets.length) { var z = zoneNow(H, w.innerHeight - B); decide(z.s, z.l); }
      else apply();
    }
    if (mode === 'form' || mode === 'row') scheduleSync();   // e.g. a price-hiding class on body
  }
  var TYPE_RE = /^(button|submit|checkbox|radio|range|color|file|image|reset|hidden)$/i;
  function typingField(t) {
    if (!t || t === d.body || bar.contains(t)) return false;
    var tag = (t.tagName || '').toLowerCase();
    return tag === 'textarea' || tag === 'select' || !!t.isContentEditable || (tag === 'input' && !TYPE_RE.test(t.type || ''));
  }
  var hdrQ = false;
  function onHeader() {
    if (hdrQ) return;
    hdrQ = true;
    raf(function () { hdrQ = false; if (Math.abs(headerCover() - H) > 2) build(); });
  }

  /* ---------------------------------------------------------------- gate (single source: the page's own gate) */
  var tFade = 0;
  function renderGate() {
    var on = guest && !gateOn;                      // never two "Account required" badges on screen at once
    if (el.gate.hidden !== on) return;
    el.gate.hidden = !on;
    // the badge fades in for this show only: a fit() that measures with the badge dropped (a rotation, a resize) must
    // not replay the fade, so the animation is tied to a class that lives just long enough for it (160 ms)
    clearTimeout(tFade);
    el.gate.classList.toggle('is-in', on);
    if (on) tFade = setTimeout(function () { el.gate.classList.remove('is-in'); }, 240);
    scheduleFit();
  }

  /* ---------------------------------------------------------------- fit (measured; never on scroll) */
  function over(x) { return !!x && x.getClientRects().length > 0 && x.scrollWidth > x.clientWidth + 1; }
  function lockButton() {                           // constant footprint: min-width = the widest state label
    el.btn.style.minWidth = '';
    var keep = el.label.textContent;
    var labels = mode === 'grid' ? [L.grid] : [idleLabel, L.added, L.soldout, keep];
    // the theme writes "Unavailable" only when an option selector matches no variant: measure it only for such forms
    var t = mode === 'grid' ? null : current();
    if (t && q('select', t.form)) labels.push(L.unavailable);
    // sold out at 600 px and up takes the empty icon slot out of the flow (centred label): measure as idle lays it out
    var inflow = state === 'soldout' && !narrowQ.matches && el.slot;
    if (inflow) el.slot.style.position = 'relative';
    var wmax = 0;
    labels.forEach(function (s) { if (!s) return; el.label.textContent = s; wmax = Math.max(wmax, el.btn.getBoundingClientRect().width); });
    el.label.textContent = keep;
    if (inflow) el.slot.style.position = '';
    if (wmax > 0) el.btn.style.minWidth = Math.ceil(wmax) + 'px';
  }
  // The chip's value box holds the widest option at all times, the way a native <select> sizes itself, so a qty pick
  // never moves the price or refits line 1 / line 2. The digits are tabular; 0 and 8 cover a font without tabular nums.
  function lockChip() {
    var qv = el.qv, n = 0;
    qv.style.minWidth = '';
    for (var i = 0; i < el.sel.options.length; i++) n = Math.max(n, el.sel.options[i].value.length);
    if (!n) return;
    var keep = qv.textContent, wmax = 0;
    [el.sel.options[el.sel.options.length - 1].value, new Array(n + 1).join('0'), new Array(n + 1).join('8')].forEach(function (s) {
      qv.textContent = s; wmax = Math.max(wmax, qv.getBoundingClientRect().width);
    });
    qv.textContent = keep;
    if (wmax > 0) qv.style.minWidth = Math.ceil(wmax) + 'px';
  }
  // The title's own text width (it grows to fill line 2, so its box says nothing about the text).
  function titleText() {
    var t = el.title;
    if (!t.getClientRects().length) return 0;
    t.style.flex = 'none';
    var wd = t.getBoundingClientRect().width;
    t.style.flex = '';
    return wd;
  }
  function line2Over(narrow) {
    if (narrow && mode !== 'grid') {
      // the title stays only with room for TITLE_MIN of it (or all of it when shorter). The 6px gap before it is the
      // last line-2 item's margin, already inside the sub's scrollWidth.
      var titleNeeds = bar.classList.contains('drop-title') ? 0 : Math.min(titleFull, TITLE_MIN);
      return el.sub.scrollWidth + titleNeeds > el.info.clientWidth + 1;
    }
    return over(el.sub);
  }
  // Line 1 needs the amount and the pack at their own widths (both flex: none): measured from the painted boxes.
  function priceOver() {
    if (el.price.hidden || !el.price.getClientRects().length) return false;
    var r = el.price.getBoundingClientRect(), right = el.amount.getBoundingClientRect().right;
    if (el.pack.getClientRects().length) right = Math.max(right, el.pack.getBoundingClientRect().right);
    return right > r.right + 0.5;
  }
  var fitQ = false;
  function scheduleFit() { if (fitQ) return; fitQ = true; raf(function () { fitQ = false; fit(); }); }
  var FIT_CLS = ['fit-p1', 'fit-p2', 'fit-p3', 'fit-t3', 'sub-empty'];
  function clearFit() {
    FIT_CLS.forEach(function (c) { bar.classList.remove(c); });
    DROP.forEach(function (k) { bar.classList.remove('drop-' + k); });
  }
  // The ladder. Up to 798 the chip is number-only on every page (CSS: a function of the width band, never of the page),
  // so line 1 and line 2 always get the same room at a given width, whatever the page, the gate or the toggle.
  function ladder(narrow) {
    var cls = bar.classList;
    clearFit();
    if (mode !== 'grid' && !el.price.hidden) {    // line 1: never truncate the price, never drop the pack
      if (narrow) {
        if (priceOver()) cls.add('fit-p1');      // amount 15px
        if (priceOver()) cls.add('fit-p2');      // the pack moves to the start of line 2
        if (priceOver()) cls.add('fit-p3');      // amount 14px
      } else if (priceOver()) cls.add('fit-t3');
    }
    var phoneLine = narrow && mode !== 'grid';
    // the full title overflows its box (line 1 settled, nothing dropped yet): the short title first, before any drop.
    // If the short title overflows too, the ellipsis and the drop order below are as before.
    var swapped = shortOn() && over(el.title) && setText(el.title, titleShort);
    if (swapped && phoneLine) titleFull = titleText();
    var drops = 0;
    for (var i = 0; i < DROP.length && line2Over(narrow); i++) {
      var k = DROP[i];
      if (k === 'title' && !phoneLine) continue;                      // elsewhere the title has its own line
      if (k === 'gate' && (el.gate.hidden || !el.gate.getClientRects().length)) continue;   // no badge shown: nothing to yield
      cls.add('drop-' + k);
      drops++;
      if (k === 'gate') cls.remove('drop-title');                     // the badge yields last; the title comes back
    }
    // a line-2 drop widened the title's box: the full title again when it now fits (else the short title stays)
    if (swapped && drops && !cls.contains('drop-title') && setText(el.title, titleLong)) {
      if (over(el.title)) setText(el.title, titleShort); else if (phoneLine) titleFull = titleText();
    }
    if (phoneLine && line2Over(narrow)) cls.add('drop-title');        // never leave a stub of the product name
  }
  function fit() {
    if (mode === 'off' || mode === '') return;
    if (fitW !== w.innerWidth) {
      fitW = w.innerWidth;
      // a width change can cross 798/799 (bar 64 <-> 72): the page reserve follows in this frame, not at the debounced build()
      var bh = barHeight() + 'px';
      if (d.documentElement.style.getPropertyValue('--pbm-satc-h') !== bh) d.documentElement.style.setProperty('--pbm-satc-h', bh);
    }
    clearFit();                                     // the button, the chip and the title are measured unfitted
    if (titleShort) setText(el.title, titleLong);   // the full title again: a wider screen shows it whenever it fits
    lockButton();
    if (mode !== 'grid') lockChip();
    var narrow = narrowQ.matches;
    titleFull = narrow && mode !== 'grid' ? titleText() : 0;
    ladder(narrow);
    // nothing left on line 2 (no SKU, count, moved pack or gate, or all dropped): take it out of the flow, so a lone
    // title centres on the same axis as the thumbnail, price, chip and button (its 2px margin-top no longer counts)
    var any = false;
    for (var c = el.sub.firstElementChild; c && !any; c = c.nextElementSibling) if (c.getClientRects().length) any = true;
    if (!any) bar.classList.add('sub-empty');
  }

  /* ---------------------------------------------------------------- phones: page wider than the screen */
  function containWideTables() {
    qa('.product__information .description table').forEach(function (t) {
      if (t.closest('.product-order-form__row')) return;
      if (!phoneQ.matches) { t.classList.remove('pbm-satc-wide'); return; }
      if (t.classList.contains('pbm-satc-wide')) return;
      var box = t.closest('.description') || t.parentElement;
      if (box && t.getBoundingClientRect().width > box.clientWidth + 1) t.classList.add('pbm-satc-wide');
    });
  }
  var vv = w.visualViewport;
  var pinQ = false;
  function zoneHit(t, r, top, bot) {
    if (r.height <= 0) return false;
    return t.__satcKind === 'full' ? (r.top >= top - 0.5 && r.bottom <= bot + 0.5) : (r.bottom > top && r.top < bot);
  }
  function placePin() {
    pinQ = false;
    if (!pinned) return;
    var h = B || barHeight();
    bar.style.setProperty('--satc-pin-top', (vv.offsetTop + vv.height - h).toFixed(1) + 'px');
    bar.style.setProperty('--satc-pin-x', vv.offsetLeft.toFixed(1) + 'px');
    bar.style.setProperty('--satc-pin-w', vv.width.toFixed(1) + 'px');
    var z = zoneNow(vv.offsetTop + H, vv.offsetTop + vv.height - h);
    decide(z.s, z.l);
  }
  function onPin() { if (pinQ) return; pinQ = true; raf(placePin); }
  function pinCheck() {                             // dormant safety net: normally never engages
    if (!vv || mode === 'off' || mode === '') return;
    // touch devices only: a desktop window with classic scrollbars (Windows, Linux, macOS "always show") has innerWidth
    // 15-17px wider than the visual viewport with no overflow at all, and needs no pin (its fixed layer is the window)
    var need = coarse && phoneQ.matches && vv.scale < 1.01 && (w.innerWidth - vv.width) > 0.5;
    if (need !== pinned) {
      pinned = need;
      bar.classList.toggle('is-pinned', need);
      if (need) { w.addEventListener('scroll', onPin, { passive: true }); vv.addEventListener('scroll', onPin); }
      else {
        w.removeEventListener('scroll', onPin);
        vv.removeEventListener('scroll', onPin);
        ['--satc-pin-top', '--satc-pin-x', '--satc-pin-w'].forEach(function (p) { bar.style.removeProperty(p); });
        build();
        return;
      }
    }
    if (pinned) onPin();
  }

  /* ---------------------------------------------------------------- boot */
  var r = resolve();
  if (!r) return;                                   // nothing to proxy: [hidden] stays, nothing on the page changes
  mode = r.mode; row = r.row; table = r.table;
  bar.setAttribute('data-ready', '1');
  bar.setAttribute('data-mode', mode);
  if (mode === 'grid') {
    setText(el.label, L.grid);
    setText(el.count, r.count === 1 ? L.one : L.other.replace(/\d+/, String(r.count)));
  }
  pageGate = q('.pbm-product-gate');
  var pb = pageGate && q('.pbm-badge', pageGate);
  if (pb && txt(pb)) {                             // guest on a gated product (noorg / personal / declined have no badge)
    guest = true;
    bar.setAttribute('data-gate', 'guest');
    setText(el.badge, txt(pb));
    var a = q('a.pbm-product-gate__signin', pageGate);
    if (a && a.getAttribute('href') && txt(a)) { el.signin.setAttribute('href', a.getAttribute('href')); setText(el.signin, txt(a)); el.signin.hidden = false; }
  }
  setTargets(r);
  if (mode !== 'grid') { bindRow(); sync(); if (mode === 'off') return; }

  el.btn.addEventListener('click', function () { if (mode === 'grid') goGrid(); else add(); });
  el.sel.addEventListener('change', function () { held = null; pushQty(el.sel.value); endPress(); });
  // Input modality. Only Tab / Shift+Tab move focus into the bar, so only they arm kbd (Shift, PageDown, Esc or an arrow
  // after a mouse focus never do). Enter / Space mark a keyboard activation for "Choose items".
  d.addEventListener('keydown', function (e) {
    inputSeq++;
    parkEl = null;
    press = 0;
    if (e.metaKey || e.ctrlKey || e.altKey) return;
    if (e.key === 'Tab') kbd = true;
    keyAct = e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar';
  }, true);
  ['pointerdown', 'mousedown', 'touchstart'].forEach(function (ty) {
    d.addEventListener(ty, function (e) {
      inputSeq++;
      kbd = false; keyAct = false; parkEl = null;
      clearTimeout(tPress);
      // a press on the bar never slides a keyboard-pinned bar out under the finger (the click would miss the button):
      // it unpins once the press has done its work (click: after add() has locked the bar in loading; a chip pick)
      if (bar.contains(e.target)) { press = el.qtybox.contains(e.target) ? 2 : 1; return; }
      press = 0;
      setKbdFocus(false);
    }, { capture: true, passive: true });
  });
  var tPress = 0;
  function endPress(e) {
    clearTimeout(tPress);
    if (!press) return;
    // the chip's press ends with its pick (change), a key, or a press elsewhere: its click comes while the picker is open
    if (press === 2 && e && e.type === 'click') return;
    press = 0;
    setTimeout(function () { if (!press) setKbdFocus(false); }, 0);   // after the bar's own click handler has run
  }
  d.addEventListener('click', endPress, true);
  ['pointercancel', 'touchcancel'].forEach(function (ty) { d.addEventListener(ty, endPress, { capture: true, passive: true }); });
  // a touch that turned into a scroll may end without click or cancel (iOS): settle it shortly after the finger lifts
  d.addEventListener('pointerup', function (e) { if (press === 1 && e.pointerType === 'touch') { clearTimeout(tPress); tPress = setTimeout(endPress, 500); } }, { capture: true, passive: true });
  bar.addEventListener('focusin', function (e) {
    // the window was re-activated (Chrome re-sends focusin to the element that had focus): keep the value it had
    if (parkEl && e.target === parkEl) { parkEl = null; return; }
    if (press) return;                              // focus moving inside the bar under a press: settled when it ends
    setKbdFocus(kbd);
  });
  bar.addEventListener('focusout', function (e) {
    if (e.relatedTarget && bar.contains(e.relatedTarget)) return;
    // the window lost focus (another tab or app): the element keeps the document's focus; nothing changes until return
    if (!e.relatedTarget && !d.hasFocus() && bar.contains(d.activeElement)) { parkEl = d.activeElement; return; }
    press = 0;
    setKbdFocus(false);
  });
  w.addEventListener('focus', function (e) {
    if (e.target === w) setTimeout(function () { parkEl = null; }, 0);   // only the focusin that comes with the return
  });
  d.addEventListener('wheel', function () { inputSeq++; }, { capture: true, passive: true });
  if (w.MutationObserver) {
    new MutationObserver(readOverlay).observe(d.body, { attributes: true, attributeFilter: ['class', 'style'] });
    ['header', 'mobile-header'].forEach(function (id) {
      var h = d.getElementById(id);
      if (!h) return;
      var mo = new MutationObserver(onHeader);                 // static <-> fixed (jquery.sticky inline style)
      mo.observe(h, { attributes: true, attributeFilter: ['style', 'class'] });
      if (h.parentElement) mo.observe(h.parentElement, { attributes: true, attributeFilter: ['style', 'class'] });
      if (w.ResizeObserver) new ResizeObserver(onHeader).observe(h);   // the stuck header shrinks after a transition
    });
  }
  d.addEventListener('focusin', function (e) { if (coarse && typingField(e.target)) { typing = true; apply(); } });
  d.addEventListener('focusout', function () {
    setTimeout(function () { typing = !!(coarse && typingField(d.activeElement)); apply(); }, 60);
  });
  overlay = false;
  readOverlay();

  // Confirmation: cart_action = reload_page, so a bar add is confirmed on the next page load (cart count rose). It is
  // read at boot, before the bar first slides in, so the bar lands already reading "Added" with the qty that was added
  // (no "Qty 1" -> "Qty 3" flip right after it lands); only the check mark's draw waits for the landing (CSS).
  try {
    var raw = w.sessionStorage.getItem(KEY);
    if (raw) {
      w.sessionStorage.removeItem(KEY);
      var rec = JSON.parse(raw);
      if (rec && Date.now() - rec.t < 120000 && cartCount() > rec.c) {
        clarity('set', 'pbm_atc_via', 'sticky_bar');
        clarity('event', 'pbm_sticky_atc_added');
        // "Added" only beside the form that was added (a case add reloads onto the each toggle: the header count confirms
        // it), and with the qty that was added
        var t0 = current(), vi = t0 && q('[name="id"]', t0.form);
        var same = !rec.v || (!!vi && String(vi.value) === String(rec.v));
        if (rec.p === pid && mode !== 'grid' && state === 'idle' && same) confirmAdded(parseInt(rec.q, 10), true);
      }
    }
  } catch (e) {}

  bar.hidden = false;
  setInert(true);
  d.documentElement.classList.add('pbm-satc-on');
  containWideTables();
  raf(function () { raf(function () { build(); fit(); pinCheck(); }); });

  var tRs = 0, lastW = w.innerWidth;
  w.addEventListener('resize', function () {
    // a new width (rotation, a breakpoint, a window drag) refits in this frame's animation callbacks, before paint: the
    // button never shows the old breakpoint's width lock and the price never paints under the chip. A height-only
    // resize (the phone URL bar on scroll) never refits.
    if (w.innerWidth !== fitW) scheduleFit();
    clearTimeout(tRs);
    tRs = setTimeout(function () {
      containWideTables();
      if (w.innerWidth !== lastW || barHeight() !== B || Math.abs(headerCover() - H) > 2) { lastW = w.innerWidth; build(); }
      scheduleFit();
      pinCheck();
    }, 150);
  });
  // the bar's CSS breakpoints: when one flips, refit at once (media query changes are reported before paint)
  ['(max-width: 359px)', '(max-width: 374px)', '(max-width: 599px)', '(max-width: 798px)'].forEach(function (s) {
    var m = mq(s);
    try { if (m.addEventListener) m.addEventListener('change', fit); else if (m.addListener) m.addListener(fit); } catch (e) {}
  });
  if (vv) vv.addEventListener('resize', function () { raf(pinCheck); });
  w.addEventListener('load', function () { pinCheck(); setTimeout(pinCheck, 1500); });
  w.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;                       // back/forward cache: never come back to a spinner
    // A page restored from the back/forward cache never saw its add land: a successful add boots the next page, which
    // consumes the record. Drop it, so a later add with the real row is never confirmed as the bar's failed attempt.
    try { w.sessionStorage.removeItem(KEY); } catch (x) {}
    clearTimeout(tAdded); clearTimeout(tAjax);
    if (unwatchNav) unwatchNav();
    if (state === 'loading' || state === 'added') setState('idle');
    typing = false;
    readOverlay();
    sync();
    ioDFor = null;                                  // every observer starts over after a restore, the direction one too
    build();
    pinCheck();
  });
})();
